import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { WorkspaceHeader } from "@/shell/WorkspaceHeader";
import { EmptyState, Button } from "@/design/components";

/**
 * Stand-in for any surface not yet built. Keeps the workspace header + switchers
 * available so a demo handler can always navigate back.
 */
export function PlaceholderScreen() {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <WorkspaceHeader />
      <main className="mx-auto flex w-full max-w-3xl flex-1 items-center px-6 py-16">
        <EmptyState
          variant="accent"
          title="This surface arrives in a later build phase"
          body={`The route ${pathname} is reserved. Foundation is in place; screens are being built demo-path first.`}
          cta={
            <Link to="/">
              <Button variant="secondary">
                <ArrowLeft className="h-4 w-4" />
                Back to foundation
              </Button>
            </Link>
          }
          className="w-full"
        />
      </main>
    </div>
  );
}
